/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PerpetualPair } from './perpetualPair';

/**
 * Funding Rate DTO.
 */
export interface FundingRateDto {
  /**
   * Associated perpetual trading pair
   */
  perpetualPair?: PerpetualPair;
  /**
   * Funding rate value
   */
  fundingRate?: number;
  /**
   * Timestamp of the funding rate
   */
  timestamp?: string;
}
